import React from 'react'
import { useLocation } from 'react-router-dom'
import SocialLogo from '../shared/SocialLogo'
import YoutubeDetails from '../components/social/partial/YoutubeDetails'
import TwitterDetails from '../components/social/partial/TwitterDetails'

function OrderItem({ socialLogo, postData, products, username, twitterData, metadata }) {
    const location = useLocation();
    const handleImgError = () => {
    }
    const subCategoryService = (subCategoryService) => {
        switch (subCategoryService) {
            case "InstaDefault":
                return "Insta";
            case "InstaImages":
            case "InstaComments":
            case "InstaCustomComments":
            case "InstaVideo":
                return "Insta";
            case "FacebookPage":
            case "FacebookPosts":
            case "FacebookVideo":
            case "FacebookComment":
            case "FacebookCustomComment":
            case "FacebookProfile":
            case "FacebookDefault":
                return "Facebook";
            case "TwitterFollow":
                return "TwitterFollow";
            case "TwitterPost":
                return "Twitter";
            case "YoutubeVideo":
            case "YoutubeCustomComments":
            case "YoutubeChannel":
                return "Youtube";
            case "SoundCloudTrack":
            case "SoundCloudArtist":
                return "SoundCloud";
            case "TikTokProfile":
                return "TikTok";
            case "TikTokPost":
            case "TikTokComments":
            case "TikTokCustomComments":
                return "TikTok";
            default:
                break;
        }
    }
    return (

        <div className='lg:max-v-screen '>
            <div className='lg:max-h-screen overflow-y-auto scrollbar '>
                {postData && ((socialLogo === "Insta")) ? (
                    <div className="flex flex-row gap-5">
                        <figure className="basis-1/4">
                            {postData[0]?.user?.profile_pic_url ? <img src={postData[0]?.user?.profile_pic_url} alt={metadata ? metadata.username : JSON.parse(products[0]?.imgOriginalLink)[1]?.username} /> : <SocialLogo serviceType={"InstaDefault"} />}
                        </figure>
                        <div className="basis-3/4">
                            <p className="text-lg font-semibold">{metadata ? metadata.full_name : JSON.parse(products[0]?.imgOriginalLink)[1]?.full_name}</p>
                            <p className="text-lg font-semibold">@{metadata ? metadata.username : JSON.parse(products[0]?.imgOriginalLink)[1]?.username}</p>
                        </div>
                    </div>
                ) : null}
                {postData && (socialLogo === "TikTok") ? (
                    <div className="flex flex-row gap-5">
                        <figure className="basis-1/4">
                            {postData[0]?.author?.avatar_168x168.url_list[0] ? <img src={postData[0]?.author?.avatar_168x168.url_list[0]} alt={products[0]?.itemComment} /> : <SocialLogo serviceType={"TikTokProfile"} />}
                        </figure>
                        <div className="basis-3/4">
                            <p className="text-lg font-semibold">{postData[0]?.author?.nickname ? postData[0]?.author?.nickname : products[0]?.itemComment}</p>
                            <p className="text-lg font-semibold">@{postData[0]?.author?.nickname ? postData[0]?.author?.nickname : products[0]?.itemComment}</p>
                        </div>
                    </div>
                ) : null}
                {twitterData && (socialLogo === "Twitter") ? (
                    <div className="flex flex-row gap-5">
                        <TwitterDetails selectedSubCategory={socialLogo} twitter={twitterData} />
                    </div>
                ) : null}
                {(socialLogo === undefined || socialLogo == null) && (subCategoryService(products[0]?.imgOriginalLink !== undefined ? JSON.parse(products[0]?.imgOriginalLink)[0] : null) === ("Twitter")) ? (
                    <div className="flex flex-row gap-5">
                        <TwitterDetails selectedSubCategory={(subCategoryService(products[0]?.imgOriginalLink !== undefined ? JSON.parse(products[0]?.imgOriginalLink)[0] : null))}
                            twitter={products[0]?.imgOriginalLink != undefined ? JSON.parse(products[0]?.imgOriginalLink)[1] : null} />
                    </div>
                ) : null}
                {
                    <section>
                        {products ? products?.map((prod, idx) => (
                            <React.Fragment key={prod?.id + "-" + idx}>
                                <div className='flex flex-row gap-1 my-2 py-2 px-2 border border-gray-350 rounded-xl min-h-20 max-h-40 w-full ' >
                                    <span className=" flex  ">
                                        <>
                                            {prod?.img64 ?
                                                <img id={prod?.linkToPage} data-url={prod?.img64} className="h-16 w-16" src={prod?.img64} onError={e => handleImgError(e, prod?.imgOriginalLink != undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null)} alt="Post" /> : null}
                                        </>
                                        {!prod?.img64 ? <SocialLogo serviceType={prod?.imgOriginalLink != undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null} /> : null}
                                    </span>
                                    <div className="flex flex-col justify-between w-full " key={idx}>
                                        <span className="font-semibold break-all  ">
                                            {(subCategoryService(prod?.imgOriginalLink != undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null) === ("TikTok")) ? (
                                                <>
                                                    <span className='text-sm bg-gray-100 text-gray-800 px-2 py-1 rounded-md '>
                                                        <a href={prod?.img64 ?
                                                            prod?.item !== null ? prod.selectedSubCategory?.linkTo + "@" + prod.itemComment + "/video/" + prod?.linkToPage : null
                                                            : prod?.item !== null ? prod.selectedSubCategory?.linkTo + "@" + prod.itemComment : null} target='_blank' rel='noopener noreferrer' className='hover:text-blue-500'>
                                                            {prod?.img64 ?
                                                                prod?.item !== null ? prod.selectedSubCategory?.linkTo + "@" + prod.itemComment + "/video/" + prod?.linkToPage : null
                                                                : prod?.item !== null ? prod.selectedSubCategory?.linkTo + "@" + prod.itemComment : null}
                                                        </a>  </span>  </>
                                            ) : null}
                                            {(subCategoryService(prod?.imgOriginalLink !== undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null) === ("Twitter")) ? (
                                                <>
                                                    <div className='flex flex-col '>
                                                        <span className='text-sm bg-gray-100 text-gray-800 px-2 py-1 rounded-md'>
                                                            <a href={prod?.item !== null ? prod.selectedSubCategory?.linkTo + JSON.parse(prod?.imgOriginalLink)[1].username + "/status/" + prod?.linkToPage : null} target='_blank' rel='noopener noreferrer' className='hover:text-blue-500'>
                                                                {prod?.item !== null ? prod.selectedSubCategory?.linkTo + JSON.parse(prod?.imgOriginalLink)[1].username : null}
                                                            </a>
                                                        </span>
                                                        <span className='text-sm'>  {prod?.itemComment}</span>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(subCategoryService(prod?.imgOriginalLink !== undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null) === ("TwitterFollow")) ? (
                                                <>
                                                    <div className='flex flex-col'>
                                                        <span className='text-sm bg-gray-100 text-gray-800 px-2 py-1 rounded-md '>
                                                            <a href={prod?.item !== null ? prod.selectedSubCategory?.linkTo + JSON.parse(prod?.imgOriginalLink)[1].username : null} target='_blank' rel='noopener noreferrer' className='hover:text-blue-500'>
                                                                {prod?.item !== null ? prod.selectedSubCategory?.linkTo + JSON.parse(prod?.imgOriginalLink)[1].username : null}
                                                            </a>
                                                        </span>
                                                        <span className='text-sm'>  {prod?.itemComment}</span>
                                                    </div>
                                                </>
                                            ) : null}

                                            {
                                                ((subCategoryService(prod?.imgOriginalLink !== undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null) !== ("Twitter")) &&
                                                    (subCategoryService(prod?.imgOriginalLink != undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null) !== ("TikTok")) &&
                                                    (subCategoryService(prod?.imgOriginalLink != undefined ? JSON.parse(prod?.imgOriginalLink)[0] : null) !== ("TwitterFollow")) &&
                                                    prod?.item != null) ?
                                                    (<>
                                                     <span className='text-sm bg-gray-100 text-gray-800 px-2 py-1 rounded-md  flex flex-col  '>
                                                        <a target='_blank' href={prod.selectedSubCategory?.linkTo + prod?.linkToPage} rel='noopener noreferrer' className='hover:text-blue-500'>
                                                            {prod.selectedSubCategory?.linkTo + prod?.linkToPage}

                                                        </a></span>
                                                    </>) : null
                                            }

                                        </span>
                                        <div className="flex flex-row gap-2 justify-between">
                                            <span className="font-semibold">
                                                <span className="font-normal">Name:</span> {prod?.item != null ? prod?.item[0]?.name : null}
                                            </span>
                                            <span className="font-semibold">
                                                <span className="font-normal">Qty:</span> {prod?.item != null ? prod?.item[0].quantity : null}
                                            </span>
                                            <span className="DDD">
                                                <span className="font-normal">Price:</span> ${prod?.item != null ? !prod?.item[0]?.discount ? prod?.item[0]?.price : prod?.item[0]?.discountPrice : null}
                                            </span>
                                        </div>
                                    </div>

                                </div>
                                {!location.pathname.includes("/checkout/1") ?
                                    <YoutubeDetails selectedSubCategory={prod.selectedSubCategory?.nameOfService} youtube={prod?.imgOriginalLink != undefined ? JSON.parse(prod?.imgOriginalLink)[1] : null} />
                                    : null}
                            </React.Fragment>
                        )) : (
                            <p>No items selected.</p>
                        )}
                    </section>}
            </div>
            {products?.length > 0 ?
                <div className="my-5 mx-2 flex flex-row justify-between font-semibold"><span className="font-semibold">Total to Pay:</span> ${products?.length > 0 && products?.map(prod => prod?.item ? !prod?.item[0]?.discount ? prod?.item[0]?.price : prod.item[0]?.discountPrice : null)?.reduce((a, b) => a + b)?.toFixed(2)}</div>
                : null}
        </div>
    )
}

export default OrderItem